<!-- Header/actions/list layout mirrors the Property Table (add-form.component.html tableSectionsAtEnd
     block): title on its own line, actions row below it, content below that. -->
<div class="faq-editor" data-testid="spu-form-faq-section">
  <h2 class="section-title text-sm">
    {{ 'goods.spu.form.faq.section_title' | translate }}
  </h2>

  @if (!viewMode) {
    <div class="flex gap-2 px-2 pt-2">
      <app-button
        [type]="'danger'"
        [outlined]="true"
        [label]="'common.actions.delete'"
        [disabled]="selectedItems().length === 0"
        testId="spu-form-faq-delete-selected"
        (emitOnClick)="requestDeleteSelected()"
      ></app-button>
      <app-button
        [type]="'info'"
        [label]="'goods.spu.form.faq.add'"
        testId="spu-form-faq-add"
        (emitOnClick)="openAddDialog()"
      ></app-button>
    </div>
  }

  <div class="px-2 pt-4">
    <app-data-table
      data-testid="spu-form-faq-table"
      [dataSource]="items"
      [columns]="columns"
      [hasSerialColumn]="true"
      [hasCheckColumn]="!viewMode"
      [selection]="selectedItems()"
      (selectionChange)="selectedItems.set($event)"
      [showPaginator]="false"
      [rows]="items.length || 1"
      [actionsTemplate]="rowActionsTemplate"
    ></app-data-table>
  </div>
</div>

<ng-template #rowActionsTemplate let-rowData>
  <div class="flex gap-1 justify-center">
    @if (!viewMode) {
      <p-button
        size="small"
        severity="secondary"
        text
        icon="pi pi-arrow-up"
        [disabled]="isFirst(rowData)"
        [attr.data-testid]="'spu-form-faq-move-up-' + rowData.tempId"
        [pTooltip]="'goods.spu.form.faq.move_up' | translate"
        (onClick)="moveItemUp(rowData.tempId)"
      ></p-button>
      <p-button
        size="small"
        severity="secondary"
        text
        icon="pi pi-arrow-down"
        [disabled]="isLast(rowData)"
        [attr.data-testid]="'spu-form-faq-move-down-' + rowData.tempId"
        [pTooltip]="'goods.spu.form.faq.move_down' | translate"
        (onClick)="moveItemDown(rowData.tempId)"
      ></p-button>
      <p-button
        size="small"
        severity="info"
        text
        [label]="
          (rowData.active
            ? 'common.table.actions.deactivate'
            : 'common.table.actions.activate'
          ) | translate
        "
        [attr.data-testid]="'spu-form-faq-toggle-status-' + rowData.tempId"
        (onClick)="requestToggleStatus(rowData)"
      ></p-button>
      <p-button
        size="small"
        severity="info"
        text
        [label]="'common.actions.edit' | translate"
        [attr.data-testid]="'spu-form-faq-edit-' + rowData.tempId"
        (onClick)="openEditDialog(rowData)"
      ></p-button>
      <p-button
        size="small"
        severity="danger"
        text
        [label]="'common.actions.delete' | translate"
        [attr.data-testid]="'spu-form-faq-delete-' + rowData.tempId"
        (onClick)="requestDeleteItem(rowData.tempId)"
      ></p-button>
    } @else {
      <p-button
        size="small"
        severity="info"
        text
        [label]="'common.actions.view' | translate"
        [attr.data-testid]="'spu-form-faq-view-' + rowData.tempId"
        (onClick)="openEditDialog(rowData)"
      ></p-button>
    }
  </div>
</ng-template>

<app-spu-faq-dialog
  data-testid="spu-form-faq-dialog"
  [visible]="dialogVisible()"
  (visibleChange)="dialogVisible.set($event)"
  [initialData]="editingItem()"
  [viewMode]="viewMode"
  (confirm)="onDialogConfirm($event)"
></app-spu-faq-dialog>

<app-confirmation-dialog
  data-testid="spu-form-faq-confirm-dialog"
  [visible]="confirmDialogVisible()"
  [title]="'common.confirmation.title'"
  [message]="confirmDialogMessage()"
  [buttons]="confirmDialogButtons()"
  (emitOnClick)="onConfirmDialogAction($event)"
  (visibleChange)="confirmDialogVisible.set($event)"
></app-confirmation-dialog>
